import { toDateInput } from 'helpers/date';

export const defaultState = {
  certId: null,
  deltaClass: null,
  status: '',
  organization: null,
  validTill: null,
  dateDeltaCertificate: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      organization: action.payload.organization?.id,
      dateDeltaCertificate: action.payload.dateDeltaCertificate
        ? toDateInput(action.payload.dateDeltaCertificate)
        : undefined,
      validTill: action.payload.validTill ? toDateInput(action.payload.validTill) : undefined,
    };
  }

  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'dateDeltaCertificate') {
      const newValidTil = new Date(action.payload.value);
      newValidTil.setFullYear(newValidTil.getFullYear() + 5);
      newValidTil.setDate(newValidTil.getDate() - 1);
      return { ...state, [action.payload.name]: action.payload.value, validTill: newValidTil };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
